/**
 * API completion keys that duplicate their children (combined section scores).
 * Omit from outro incomplete table and fund-card completion breakdowns.
 */
export const FUND_SETUP_COMPLETION_AGGREGATE_KEYS = new Set([
  'sustainableObjectiveSection',
])

export const SUSTAINABLE_OBJECTIVE_FORM_COMPLETION_KEY_PREFIX =
  'sustainableObjectiveForm_'

export const sustainableObjectiveFormCompletionKey = (objectiveId: number | string) =>
  `${SUSTAINABLE_OBJECTIVE_FORM_COMPLETION_KEY_PREFIX}${objectiveId}`

export const isSustainableObjectiveFormCompletionKey = (key: string) =>
  key.startsWith(SUSTAINABLE_OBJECTIVE_FORM_COMPLETION_KEY_PREFIX)

/** Outro/card section label key for per-objective form completion rows. */
export const sustainableObjectiveFormCompletionSectionLabelKey = (key: string) =>
  isSustainableObjectiveFormCompletionKey(key)
    ? 'sustainableObjectiveForm'
    : key

export const isFundSetupCompletionLeafKey = (key: string) =>
  !FUND_SETUP_COMPLETION_AGGREGATE_KEYS.has(key)
